/**
 * Created by Ivan on 13.06.2025
 */

const RecipeIconAnimations = {};

RecipeIconAnimations.SLIDE = {
    duration: 0.6,
    offset: 1.2,
    period: 0.7
};

RecipeIconAnimations.slideChildren = function (dx, easing) {
    const slide = RecipeIconAnimations.SLIDE;
    const actions = this.children.map((child) => new cc.TargetedAction(child, new cc.MoveBy(slide.duration, dx, 0).easing(easing)));

    if (!actions.length) {
        return new cc.DelayTime(0);
    }

    return actions.length === 1 ? actions[0] : new cc.Spawn(actions);
};

RecipeIconAnimations.slideInAnimation = function () {
    const person = this.person;
    const slide = RecipeIconAnimations.SLIDE;
    const offset = this.width * slide.offset;
    const positions = this.children.map((child) => child.getPosition());

    this.children.forEach((child) => {
        child.setPositionX(child.x - offset);
    });

    return new cc.Sequence(
        new cc.DelayTime(RecipeIconAnimations.calcMakeRoomDuration.call(this)),
        new cc.CallFunc(() => {
            if (person && person.setAnimationAndIdleAfter) {
                person.setAnimationAndIdleAfter("show", "idle");
            }
        }),
        RecipeIconAnimations.slideChildren.call(this, offset, cc.easeElasticOut(slide.period))
    ).setFinalize(() => {
        this.children.forEach((child, index) => {
            if (positions[index]) {
                child.setPosition(positions[index]);
            }
        });
        cleverapps.eventBus.trigger("addRowAnimationFinish");
    });
};

RecipeIconAnimations.slideOutAnimation = function () {
    const person = this.person;
    const slide = RecipeIconAnimations.SLIDE;

    return new cc.Sequence(
        new cc.CallFunc(() => {
            if (person && person.setAnimation) {
                person.setAnimation(0, "hide", false);
            }
        }),
        RecipeIconAnimations.slideChildren.call(this, -this.width * slide.offset, cc.easeElasticIn(slide.period))
    );
};

RecipeIconAnimations.addRowAnimation = function () {
    if (!cleverapps.resolution.isVertical()) {
        return RecipeIconAnimations.slideInAnimation.call(this);
    }

    const person = this.person;
    this.children.forEach((child) => {
        child.setVisible(false);
    });
    const baseScale = this.getScale();

    const actions = [
        new cc.DelayTime(RecipeIconAnimations.calcMakeRoomDuration.call(this)),
        new cc.CallFunc(
            () => {
                this.children.forEach((child) => {
                    child.setVisible(true);
                });
                if (person) {
                    person.setVisible(false);
                }
            }
        ),
        new cc.CallFunc(() => {
            this.setScale(baseScale * 0.6);
            if (!person || !person.isRunning()) {
                return;
            }

            person.runAction(new cc.Sequence(
                new cc.DelayTime(0.35),
                new cc.Show(),
                new cc.CallFunc(
                    () => {
                        person.setAnimationAndIdleAfter("show", "idle");
                    }
                )
            ));
        }),
        new cc.ScaleTo(0.8, baseScale).easing(cc.easeBackOut(3))
    ];

    return new cc.Sequence(actions).setFinalize(() => {
        this.setScale(baseScale);
        this.children.forEach((child) => {
            child.setVisible(true);
        });
        cleverapps.eventBus.trigger("addRowAnimationFinish");
    });
};

RecipeIconAnimations.calcMoveDuration = function (distance) {
    return Math.min(distance / 1000, RecipeIconAnimations.MOVE_DURATION);
};

RecipeIconAnimations.calcMakeRoomDuration = function () {
    const shift = cleverapps.resolution.isVertical() ? this.width : this.height;
    return RecipeIconAnimations.MOVE_DELAY + RecipeIconAnimations.calcMoveDuration(shift);
};

RecipeIconAnimations.moveRowAnimation = function (endPosition) {
    const duration = RecipeIconAnimations.calcMoveDuration(cc.pDistance(this.getPosition(), endPosition));
    return new cc.Sequence(
        new cc.DelayTime(RecipeIconAnimations.MOVE_DELAY),
        new cc.MoveTo(duration, endPosition)
    );
};

RecipeIconAnimations.MOVE_DELAY = 0.05;
RecipeIconAnimations.MOVE_DURATION = 0.4;

RecipeIconAnimations.removeRowAnimation = function () {
    if (!cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTableHiding.isShown) {
        return new cc.DelayTime(0);
    }

    const person = this.person;
    const actions = [new cc.DelayTime(1.5)];

    if (!cleverapps.resolution.isVertical()) {
        actions.push(RecipeIconAnimations.slideOutAnimation.call(this));
        return new cc.Sequence(actions);
    }

    if (person) {
        actions.push(new cc.CallFunc(() => {
            person.setAnimation(0, "hide", false);
        }));
        actions.push(new cc.DelayTime(person.getAnimationDuration("hide")));
    }

    return new cc.Sequence(actions);
};
